import React from "react";
import {connect} from "react-redux";
import ColAtm from "../../../atomic/Col/Col";
import Container from "@material-ui/core/Container";
import {Animated} from "react-animated-css";
import {PageTitle} from "../../../atomic/PageHeader/PageTitle";
import PageHeaderAtm from "../../../atomic/PageHeader/PageHeader";
import {Link} from "react-router-dom";
import LabelAtm from "../../../atomic/Label/Label";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import ButtonAtm from "../../../atomic/Button/Button";
import {getProfile} from "../../../../redux/actions/User/Profile/profileAction";
import {getBookingEngineDashboard} from "../../../../redux/actions/BookingEngine/BookingEngineDashboard/BookingEngineDashboard.actions";
import Grid from "@material-ui/core/Grid";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import {makeStyles} from "@material-ui/core/styles";
import {CircularProgress, Hidden} from "@material-ui/core";
import {
    APP,
    CONTENT,
    NETWORK,
    OFFER,
    WEB,
    PAYMENT,
    NETWORK_CHANNEL_INFORMATION_SHORT,
    NETWORK_CHANNEL_SETUP_SHORT, NOT_ALLOWED_DASHBOARD_SHORT,
    NETWORK_COMPETITOR, REPUTATION_MANAGEMENT,
    NETWORK_PROMOTION, NETWORK_PROMOTION_CHANNEL_LIST,
    NETWORK_ADDONS_CHANNEL_LIST, NETWORK_COUPONS_CHANNEL_LIST,
    NETWORK_PROMOTION_SHORT, NETWORK_INVENTORY_LIST,
    NETWORK_INVENTORY_SHORT, NETWORK_RESERVATIONS,
    NETWORK_COMPETITOR_DASH, NETWORK_CHANNELS,
    
} from "../../../../constants/appUrls.constants";
import BottomNavigation from "@material-ui/core/BottomNavigation/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import {history} from "../../../../utils/history";
import CssBaseline from "@material-ui/core/CssBaseline";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import {getPropertyName, isDefined} from "../../../../utils";
import BookingEnginePreviewDialog from "../components/PreviewWeb/BookingEnginePreviewDialog";
import Tooltip from "@material-ui/core/Tooltip";
import Paper from "@material-ui/core/Paper";
import {propertyProducts} from "../../../../redux/actions/propertyProductsActions";
import NotAllowedPage from "../../Global/NotAllowedPage/NotAllowedPage";
import Charts from "../../Global/Charts";
import { DAILY_REPORTS } from "../../../../constants/appUrls.constants";
import { getProperty } from "../../../../utils";
import 'pure-react-carousel/dist/react-carousel.es.css';
import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';
import { getNetworkDashboard } from "../../../../redux/actions/Network/Dashboard/networkDashboard.actions";
import { CarouselProvider, Slide, Slider } from "pure-react-carousel";
import { listChannels } from "../../../../redux/actions/channelListActions";

import DashboardBottomActions from "../../../molecules/DashboardBottomActions/DashboardBottomActions";
let t=null;
const drawerWidth = 91;
const drawerWidthCollapsed = 280; // 82
const drawerWidthExpanded = 280;
const leftMenuWidth = 252;

const useStyles = makeStyles(theme => ({
    root: {
        display: 'block',
        width: '100%',
    },
    drawer: {
        width: drawerWidthCollapsed,
        flexShrink: 0,
        zIndex: '999',
    },
    leftMenu: {
        width: 0,
        flexShrink: 0,
    },
    leftMenuPaper: {
        width: leftMenuWidth,
        marginLeft: 102,
        marginTop: 81
    },
    drawerPaper: {
        width: drawerWidthCollapsed,
        height: 'calc(100vh - 81px)',
        marginTop: '81px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
        borderRight: '1px solid #e2e8f0',
        padding: '20px 12px',
        overflowX: 'hidden',
        overflowY: 'auto',
        transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&::-webkit-scrollbar': {
            width: 4,
        },
        '&::-webkit-scrollbar-track': {
            background: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#d1d5db',
            borderRadius: 4,
        },
        '@media (min-width: 960px) and (max-width: 1600px)': {
            height: 'calc(125vh - 101px)',
            minHeight: 'calc(125vh - 101px)',
        },
    },
    sidebarList: {
        padding: 0,
        margin: 0,
        listStyle: 'none',
        flex: '1 1 auto',
    },
    sidebarLink: {
        textDecoration: 'none',
        display: 'block',
        marginBottom: 8,
        '&:focus': {
            outline: 'none',
        },
    },
    sidebarItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '12px 12px',
        borderRadius: 47,
        cursor: 'pointer',
        transition: 'background 0.2s ease',
        background: 'transparent',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        '&:hover': {
            background: '#f1f5f9',
        },
    },
    sidebarItemActive: {
        background: 'linear-gradient(135deg, #d71f26 0%, #ff4757 100%)',
        '&:hover': {
            background: 'linear-gradient(135deg, #d71f26 0%, #ff4757 100%)',
        },
    },
    sidebarIconWrapper: {
        minWidth: 34,
        width: 34,
        height: 34,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    sidebarIcon: {
        fontSize: 18,
        color: '#64748b',
        transition: 'color 0.2s ease',
    },
    sidebarIconActive: {
        color: '#fff',
    },
    sidebarText: {
        fontSize: "13px !important",
        fontWeight: 600,
        color: '#475569',
        marginLeft: 14,
        opacity: 1,
        transition: 'opacity 0.2s ease 0.1s',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        pointerEvents: 'none',
    },
    sidebarTextVisible: {
        opacity: 1,
    },
    sidebarTextActive: {
        color: '#fff',
    },
    sidebarDivider: {
        height: 1,
        background: '#e2e8f0',
        margin: '10px 8px',
        transition: 'margin 0.3s ease',
        '$drawerPaper:hover &': {
            margin: '10px 12px',
        },
    },
    chartsWrapper: {
        flex: '0 0 auto',
        padding: '16px 0',
        borderTop: '1px solid #e2e8f0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    leftBarShift: {
        width: `calc(100% - ${leftMenuWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: theme.spacing(2),
        backgroundColor: '#ffffff',
        padding: '11px 12.14px'
    },
    hide: {
        display: 'none',
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 125,
        marginRight: -60,
        paddingRight: 120,
    },
    content: {
        flexGrow: 1,
        padding: '24px 68px',
    },
    toolbar: theme.mixins.toolbar,
}));

class CreateWeb extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showSuccessHeader: false,
            open : false,
            open_preview: false,
            copied: false,
            copiedTokenWithDomain: false
        };
        t = props.t;
    }

    handleClickOpen = () => {
        this.setState({open:true});
    };

    handleClickOpenPreview = () => {
        this.setState({open_preview:true});
    };

    handleClose = () => {
        this.setState({open:false, open_preview:false});
    };

    handlePreviewClose = () => {
        this.setState({open_preview:false});
    };

    componentDidMount() {
        document.body.style.backgroundColor = "#f4f7fc";
        this.props.getProfile();
        this.props.getBookingEngineDashboard();
        this.props.propertyProducts();
        this.props.getNetworkDashboard();
        this.props.listChannels();
    }

    handleCopy = (e, copyText) =>  {
        e.preventDefault();
        if (navigator && navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
            navigator.clipboard.writeText(copyText)
                .then(() => {
                    this.setState({copied:true});
                    setTimeout(() => {
                        this.setState({copied: false});
                    }, 2000);
                })
                .catch(() => {});
        } else {
            const textArea = document.createElement("textarea");
            textArea.value = copyText;
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
                this.setState({copied:true});
                setTimeout(() => {
                    this.setState({copied: false});
                }, 2000);
            } catch (err) {}
            document.body.removeChild(textArea);
        }
    }
    
    handleCopyTokenWithDomain = (e, copyText) =>  {
        e.preventDefault();
        if (navigator && navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
            navigator.clipboard.writeText(copyText)
                .then(() => {
                    this.setState({copiedTokenWithDomain:true});
                    setTimeout(() => {
                        this.setState({copiedTokenWithDomain: false});
                    }, 2000);
                })
                .catch(() => {});
        } else {
            const textArea = document.createElement("textarea");
            textArea.value = copyText;
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
                this.setState({copiedTokenWithDomain:true});
                setTimeout(() => {
                    this.setState({copiedTokenWithDomain: false});
                }, 2000);
            } catch (err) {}
            document.body.removeChild(textArea);
        }
    }
    headerStatusShow = () =>{
        return  <PageHeaderAtm backButton={APP}
                               exitText={ t('btn-properties')}
                               text={ getPropertyName() }
                               showSuccessHeader={this.props.createStatus}
        />
    };

    render() {

        const allowedPage = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "booking-engine" === item.route)

        const allowedPageNetwork = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "network" === item.route)

        const allowedPageOffer = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "offer" === item.route)

        const allowedPageWeb = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "web" === item.route)

        const allowedPageBookingEngine = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "booking-engine" === item.route)

        const allowedPagePayment = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "payment" === item.route)

        const propertyProductCompetitor = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "competitor-analysis" === item.route)

        const allowedPageReputationManagement = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "reputation-management" === item.route)

        const propertyId = Number(getProperty());

        const bookingEngineProduct = !this.props.propertyProductsReducer?.fetching &&
            isDefined(this.props.propertyProductsReducer?.get_products)
                ? Object.values(this.props.propertyProductsReducer.get_products.data).find(item => item.route === "booking-engine")
                : null;

        const showDailyReports = isDefined(bookingEngineProduct) &&
            (bookingEngineProduct.parameters?.length === 0 || bookingEngineProduct.parameters?.some(p => p?.product_parameter_id === 509 && p?.is_selected === 1));

        function Sidebar(props) {
            const classes = useStyles();
            const [isExpanded, setIsExpanded] = React.useState(false);
            const hoverTimeoutRef = React.useRef(null);
            const isNavigatingRef = React.useRef(false);

            const handleMouseEnter = () => {
                if (isNavigatingRef.current) return;
                
                if (hoverTimeoutRef.current) {
                    clearTimeout(hoverTimeoutRef.current);
                }
                setIsExpanded(true);
            };

            const handleMouseLeave = () => {
                if (hoverTimeoutRef.current) {
                    clearTimeout(hoverTimeoutRef.current);
                }
                hoverTimeoutRef.current = setTimeout(() => {
                    if (!isNavigatingRef.current) {
                        setIsExpanded(false);
                    }
                }, 100);
            };

            const handleLinkClick = (e) => {
                isNavigatingRef.current = true;
                
                const currentExpanded = isExpanded;
                
                setTimeout(() => {
                    isNavigatingRef.current = false;
                    setIsExpanded(currentExpanded);
                }, 500);
            };

            // Cleanup
            React.useEffect(() => {
                return () => {
                    if (hoverTimeoutRef.current) {
                        clearTimeout(hoverTimeoutRef.current);
                    }
                };
            }, []);

            const sidebar = (
                <div className={classes.root}>
                    <Drawer
                        className={classes.drawer}
                        variant="permanent"
                        classes={{
                            paper: classes.drawerPaper + " left-sidebar",
                        }}
                        PaperProps={{
                            onMouseEnter: handleMouseEnter,
                            onMouseLeave: handleMouseLeave,
                            style: {
                                width: isExpanded ? drawerWidthExpanded : drawerWidthCollapsed,
                            },
                        }}
                    >
                        <List className={classes.sidebarList}>
                            {props.siderbarItems.map((post, key) => (
                                <React.Fragment key={key}>
                                    <Link 
                                        to={post.link} 
                                        className={classes.sidebarLink}
                                        onClick={handleLinkClick}
                                    >
                                        <Box 
                                            className={`${classes.sidebarItem} ${post.isActive ? classes.sidebarItemActive : ''}`}
                                        >
                                            <Box className={classes.sidebarIconWrapper}>
                                                <i 
                                                    className={`${post.icon} ${classes.sidebarIcon} ${post.isActive ? classes.sidebarIconActive : ''}`} 
                                                />
                                            </Box>
                                            <Typography 
                                                className={`${classes.sidebarText} ${post.isActive ? classes.sidebarTextActive : ''} ${isExpanded ? classes.sidebarTextVisible : ''}`}
                                            >
                                                {post.text}
                                            </Typography>
                                        </Box>
                                    </Link>
                                </React.Fragment>
                            ))}
                        </List>
                        {/* Panel + Site Ayarları: logonun üstünde */}
                        <DashboardBottomActions />

                        <Box className={classes.chartsWrapper}>
                            <Charts />
                        </Box>
                    </Drawer>
                </div>
            );
            return (
                <>
                    {sidebar}
                </>
            );
        }

        const siderbarItems = [
            {id: 1, isActive: false, text: `${ t('enw-product_one-title') }`, icon: 'fas fa-hotel', link:"content"},
            {id: 4, isActive: false, text: `${t('enw-product_four-title') }`, icon: 'fas fa-network-wired', link: !this.props.propertyProductsReducer.fetching ? isDefined(allowedPageWeb[0]) && allowedPageWeb[0].property_has_product ? "web" : NOT_ALLOWED_DASHBOARD_SHORT + "/web" : "#"},
            {id: 5, isActive: true, text: `${t('enw-product_six-title')}`, icon: 'fas fa-calendar-alt', link: !this.props.propertyProductsReducer.fetching ? isDefined(allowedPageBookingEngine[0]) && allowedPageBookingEngine[0].property_has_product ? "booking-engine" : NOT_ALLOWED_DASHBOARD_SHORT + "/booking-engine" : "#"},
            {id: 6, isActive: false, text: `${t('enw-product_five-title') }`, icon: 'fas fa-money-bill-wave-alt', link: !this.props.propertyProductsReducer.fetching ? isDefined(allowedPagePayment[0]) && allowedPagePayment[0].property_has_product ? "payment" : NOT_ALLOWED_DASHBOARD_SHORT + "/payment" : "#"},
            {id: 3, isActive: false, text: `${t('enw-product_three-title') }`, icon: 'fas fa-paperclip', link: !this.props.propertyProductsReducer.fetching ? isDefined(allowedPageOffer[0]) && allowedPageOffer[0].property_has_product ? "offer" : NOT_ALLOWED_DASHBOARD_SHORT + "/offer" : "#"},
            {id: 2, isActive: false, text: `${t('enw-product_two-title') }`, icon: 'fas fa-chart-network', link: !this.props.propertyProductsReducer.fetching ? isDefined(allowedPageNetwork[0]) && allowedPageNetwork[0].property_has_product ? "network" : NOT_ALLOWED_DASHBOARD_SHORT + "/network" : "#"},
            {id: 7, isActive: false, text: (
                <>
                    {t('enw-input-competitor')}
                    <span className="newBadge">{t('enw-new_title')}</span>
                </>
            ), icon: 'fas fa-analytics', link: NETWORK_COMPETITOR_DASH },
            {id: 8, isActive: false, text: (
                    <>
                        {t('enw-reputation_management-title')}
                        <span className="newBadge">{t('enw-new_title')}</span>
                    </>
            ), icon: 'fas fa-comments-alt', link: !this.props.propertyProductsReducer.fetching ? isDefined(allowedPageReputationManagement[0]) && allowedPageReputationManagement[0].property_has_product ? REPUTATION_MANAGEMENT : NOT_ALLOWED_DASHBOARD_SHORT + "/reputation-management" : "#" },
        ];

        const {bookingEngine, bookingEngineReducer} = this.props;

        return (
            <>
                <PageTitle title={ t('be-search-booking_engine-title') } />
                {
                    this.headerStatusShow()
                }

                <Grid container className="web-dashboard">
                    <Grid item md={1} className="m-none" style={{ height: 'fit-content'}}>
                        <Sidebar siderbarItems={siderbarItems} />
                    </Grid>
                    <Grid item xs={12} className="m-auto">
                        <div>
                            <CssBaseline />
                            {
                                isDefined(allowedPage[0]) && !allowedPage[0].property_has_product ?
                                    <Grid item xs={12} lg={6} className="no-buy-product no-buy-product-web">
                                        <Card className="p-24">
                                            <NotAllowedPage />
                                        </Card>
                                    </Grid>
                                    :
                                    <Grid container spacing={3} className="be-container-width">
                                        {
                                            isDefined(bookingEngine.booking_engine) && !bookingEngine.booking_engine.is_booking_engine_active ?
                                                <Grid item md={6} xs={12} className="m-auto">
                                                    <Animated animationIn="bounceInRight" animationInDuration={1000} isVisible={true}>
                                                        <Container maxWidth="xl">
                                                            <div className="container-width">
                                                                <ColAtm xs={12} className="photoButtonsRow one-page-content">
                                                                    <Link to={{ pathname: NETWORK_CHANNEL_INFORMATION_SHORT + 1, state: { fromBookingEngine: true }}}>
                                                                        <ColAtm>
                                                                            <div className="m-auto first-create-room">
                                                                    <span>
                                                                       <ButtonAtm
                                                                           buttontext={ t('btn-new_room') }
                                                                           className="filter-action-button"
                                                                           startIcon={<i className="fas fa-laptop" />}
                                                                       />
                                                                    </span>
                                                                            </div>
                                                                        </ColAtm>
                                                                        <LabelAtm labelClass="one-page-title" text={ t('btn-create_be') } />
                                                                        <LabelAtm labelClass="one-page-subtitle p-0-100" text={ t('enw-be-create_title') } />
                                                                    </Link>
                                                                </ColAtm>
                                                            </div>
                                                        </Container>
                                                    </Animated>
                                                </Grid>
                                                :
                                                <Grid item sm={8} lg={8} className="m-auto web-stats be-dashboard-items">
                                                    <Grid container spacing={3}>
                                                        <Grid item md={8} xs={12} className="m-auto pt-20">
                                                            <Card className="offer-dashboard__box-shadow web-dashboard booking-dashboard" item xs={12}>
                                                                <>
                                                                    <Link
                                                                        className="p-0"
                                                                        to={{pathname: NETWORK_RESERVATIONS, state: { fromBookingEngine: true }}}
                                                                    >
                                                                        <Box className="general_dashboard bg-orange" component="fieldset" mb={3} borderColor="transparent">
                                                                            <i className="fas fa-concierge-bell fs-65" style={{color: "#ec8123"}} />
                                                                            <Typography className="reservation-title" gutterBottom>
                                                                                <span className="d-block" />
                                                                            </Typography>
                                                                        </Box>
                                                                    </Link>

                                                                    <CardContent className="min-height-156 pt-20 pr-24 pl-24">
                                                                        {/* <ColAtm> */}
                                                                            {/* <ColAtm md={8} xl={12}> */}
                                                                                <Link
                                                                                    className="p-0"
                                                                                    to={{pathname: NETWORK_RESERVATIONS, state: { fromBookingEngine: true }}}
                                                                                >
                                                                                    <Grid container alignItems="center" justifyContent="space-between">
                                                                                        <Grid item xs={11}>
                                                                                            <Typography className="orange" gutterBottom variant="h5" component="h2">
                                                                                                { t('enw-reservation-title') }
                                                                                            </Typography>
                                                                                        </Grid>
                                                                                        <Grid item xs={1}>
                                                                                            <Typography className="completed-step be-rez-arrow" gutterBottom variant="h5" component="p">
                                                                                                <span><i className="fas fa-arrow-right orange" /></span>
                                                                                            </Typography>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                    <Grid container alignItems="center">
                                                                                        <Typography className="mb-24" variant="body2" color="textSecondary" component="p">
                                                                                            {t('enw-pab-dashboard-reservation-desc')}
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                </Link>
                                                                            {/* </ColAtm>
                                                                        </ColAtm> */}
                                                                        {/* <Typography variant="body2" color="textSecondary" component="p">
                                                                            <Grid container>
                                                                                <Grid item xs={11}>
                                                                                    { t('enw-myw-domain_title') } : <Link to={{pathname: isDefined(bookingEngine.booking_engine) && bookingEngine.booking_engine.booking_engine_url}} target="_blank">
                                                                                    {isDefined(bookingEngine.booking_engine) && bookingEngine.booking_engine.booking_engine_url}
                                                                                </Link>
                                                                                </Grid>
                                                                                <Grid item xs={1}  className="be-copy-icon">
                                                                                    <Tooltip title={this.state.copied ? t('btn-copied') : t('btn-copy')}>
                                                                                        <i className="fas fa-copy"
                                                                                           onClick={(e) => this.handleCopy(e, isDefined(bookingEngine.booking_engine) && bookingEngine.booking_engine.booking_engine_url)} />
                                                                                    </Tooltip>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Typography>
                                                                        <Typography variant="body2" color="textSecondary" component="p">
                                                                            { t('enw-myw-token') } :  <b> {isDefined(bookingEngine.booking_engine) && bookingEngine.booking_engine.token} </b>
                                                                        </Typography> */}
                                                                        <ColAtm className="reservation-list-carousel">
                                                                            <CarouselProvider
                                                                                visibleSlides={7}
                                                                                totalSlides={7}
                                                                                step={1}
                                                                                naturalSlideWidth={400}
                                                                                naturalSlideHeight={500}
                                                                            >
                                                                                <Slider className="reservation-carousel">
                                                                                    {!this.props.networkDashboardReducer.fetching && isDefined(this.props.networkDashboardReducer.networkDashboardData.reservation_count) ?
                                                                                        Object.values(this.props.networkDashboardReducer.networkDashboardData.reservation_count).map((reservation, i) => (
                                                                                            <Slide index={i} key={i}><span>{ t(reservation.abbreviation_day) }</span>{reservation.count}</Slide>
                                                                                        ))
                                                                                        :
                                                                                        <CircularProgress className="rm-circular-progress" color="inherit" size={28} />
                                                                                    }
                                                                                </Slider>
                                                                            </CarouselProvider>
                                                                        </ColAtm>
                                                                        <BookingEnginePreviewDialog
                                                                            handleClickOpenPreview = {this.handleClickOpenPreview}
                                                                            handlePreviewClose = {this.handlePreviewClose}
                                                                            open_preview ={this.state.open_preview}
                                                                            url={isDefined(bookingEngine.booking_engine) && bookingEngine.booking_engine.booking_engine_url}
                                                                            openSetup={this.handleClickOpen}
                                                                            closeSetup = {this.handleClose}
                                                                        />

                                                                        <Divider className="mt-22" />

                                                                        <div className="mt-22">
                                                                            <Grid container justify="center" spacing={3}>
                                                                                <Grid item xs={12} md={4}>
                                                                                    <div className="d-grid">
                                                                                        <Link
                                                                                            className={"site-edit-btn"}
                                                                                            to={{
                                                                                                pathname:
                                                                                                    Object.values(this.props.channel_list || {}).some(
                                                                                                        channel => channel?.channel_category_id !== 3 && channel?.channel_category_id !== 4
                                                                                                    )
                                                                                                        ? NETWORK_CHANNELS
                                                                                                        : NETWORK_CHANNEL_SETUP_SHORT + 1,
                                                                                                state: { fromBookingEngine: true }
                                                                                            }}>
                                                                                            {t('btn-edit')}
                                                                                        </Link>
                                                                                    </div>
                                                                                </Grid>
                                                                                <Grid item xs={12} md={4}>
                                                                                    <div className="d-grid">
                                                                                        <Tooltip title={this.state.copied ? t('btn-copied') : t('btn-copy')}>
                                                                                            <Button
                                                                                                className={"site-edit-btn p-9"}
                                                                                                onClick={(e) => this.handleCopy(e, isDefined(bookingEngine.booking_engine) && bookingEngine.booking_engine.booking_engine_url)}
                                                                                                style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', justifyContent: "center" }}
                                                                                            >
                                                                                                {t('btn-copy_domain')}
                                                                                                {this.state.copied ? (
                                                                                                    <i className="fas fa-check" style={{ marginLeft: 8 }} />
                                                                                                ) : (
                                                                                                    <i className="fas fa-copy" style={{ marginLeft: 8 }} />
                                                                                                )}
                                                                                            </Button>
                                                                                        </Tooltip>
                                                                                    </div>
                                                                                </Grid>
                                                                                <Grid item xs={12} md={4}>
                                                                                    <div className="d-grid">
                                                                                        <Tooltip title={this.state.copiedTokenWithDomain ? t('btn-copied') : t('btn-copy')}>
                                                                                            <Button
                                                                                                className={"site-edit-btn p-9"}
                                                                                                onClick={(e) => this.handleCopyTokenWithDomain(e, isDefined(bookingEngine.booking_engine) && bookingEngine.booking_engine.token)}
                                                                                                style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', justifyContent: "center" }}
                                                                                            >
                                                                                                {t('btn-copy_token')}
                                                                                                {this.state.copiedTokenWithDomain ? (
                                                                                                    <i className="fas fa-check" style={{ marginLeft: 8 }} />
                                                                                                ) : (
                                                                                                    <i className="fas fa-copy" style={{ marginLeft: 8 }} />
                                                                                                )}
                                                                                            </Button>
                                                                                        </Tooltip>
                                                                                    </div>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </div>
                                                                    </CardContent>
                                                                </>

                                                            </Card>
                                                        </Grid>
                                                        <Grid item md={4} xs={12} className="m-auto">
                                                            <Grid container spacing={3} className="mobile-offer-boxes-padding">
                                                                <Grid item xs={6}>
                                                                    <Paper className="offer-boxes">
                                                                        <ColAtm sm={12} className="pt-26">
                                                                            <i className="fas fa-calendar-check green fs-22 bg-icon-green m-auto b-r-50" />
                                                                        </ColAtm>
                                                                        <ColAtm sm={12}>
                                                                    <span className="payment-info-text m-auto f-w-bold">
                                                                         {
                                                                             bookingEngineReducer.fetching ?
                                                                                 <CircularProgress className="rm-circular-progress" color="secondary"/> :
                                                                                 (
                                                                                     <>{bookingEngineReducer.bookingEngineData.success_booking_count}</>
                                                                                 )
                                                                         }
                                                                    </span>
                                                                        </ColAtm>
                                                                        <ColAtm sm={12}>
                                                                            <span className="offer-total-title">  { t('enw-booking_engine-dashboard-successful_bookings') } </span>
                                                                        </ColAtm>
                                                                    </Paper>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Paper className="offer-boxes">
                                                                        <ColAtm sm={12} className="pt-26">
                                                                            <i className="fas fa-ballot-check orange fs-22 bg-icon-orange m-auto b-r-50" />
                                                                        </ColAtm>
                                                                        <ColAtm sm={12}>
                                                                    <span className="payment-info-text m-auto f-w-bold">
                                                                          {
                                                                              bookingEngineReducer.fetching ?
                                                                                  <CircularProgress className="rm-circular-progress" color="secondary"/> :
                                                                                  (
                                                                                      <>{bookingEngineReducer.bookingEngineData.all_booking_count}</>
                                                                                  )
                                                                          }
                                                                    </span>
                                                                        </ColAtm>
                                                                        <ColAtm sm={12}>
                                                                            <span className="offer-total-title"> { t('enw-booking_engine-dashboard-all_booking') } </span>
                                                                        </ColAtm>
                                                                    </Paper>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Paper className="offer-boxes">
                                                                        <ColAtm sm={12} className="pt-26">
                                                                            <i className="fas fa-funnel-dollar purple fs-22 bg-icon-purple m-auto b-r-50" />
                                                                        </ColAtm>
                                                                        <ColAtm sm={12}>
                                                                    <span className="payment-info-text m-auto f-w-bold">
                                                                          {
                                                                              bookingEngineReducer.fetching ?
                                                                                  <CircularProgress className="rm-circular-progress"  color="secondary"/> :
                                                                                  (
                                                                                      <>{bookingEngineReducer.bookingEngineData.conversion_rate}</>
                                                                                  )
                                                                          }
                                                                    </span>
                                                                        </ColAtm>
                                                                        <ColAtm sm={12}>
                                                                            <span className="offer-total-title"> { t('enw-booking_engine-dashboard-conversion_count') } </span>
                                                                        </ColAtm>
                                                                    </Paper>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Paper className="offer-boxes">
                                                                        <ColAtm sm={12} className="pt-26">
                                                                            <i className="fas fa-users blue fs-22 bg-icon-blue m-auto b-r-50" />
                                                                        </ColAtm>
                                                                        <ColAtm sm={12}>
                                                                    <span className="payment-info-text m-auto f-w-bold">
                                                                          {
                                                                              bookingEngineReducer.fetching ?
                                                                                  <CircularProgress className="rm-circular-progress" color="secondary"/> :
                                                                                  (
                                                                                      <>{bookingEngineReducer.bookingEngineData.total_pax_count}</>
                                                                                  )
                                                                          }
                                                                    </span>
                                                                        </ColAtm>
                                                                        <ColAtm sm={12}>
                                                                            <span className="offer-total-title"> { t('enw-booking_engine-dashboard-guest_count') } </span>
                                                                        </ColAtm>
                                                                    </Paper>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <Card className="offer-dashboard__box-shadow pab-dashboard-elements">
                                                            <Link to={{
                                                                    pathname:
                                                                        Object.values(this.props.channel_list || {}).some(
                                                                            channel => channel?.channel_category_id !== 3 && channel?.channel_category_id !== 4
                                                                        )
                                                                            ? NETWORK_INVENTORY_LIST
                                                                            : NETWORK_INVENTORY_SHORT + "/1",
                                                                    state: { fromBookingEngine: true }
                                                                }}>
                                                                <Card>
                                                                <Grid container spacing={3}>
                                                                    <ColAtm>
                                                                    <ColAtm className="inventory-dashboard" item xs={4}>
                                                                        <i className="far fa-calendar-alt" />
                                                                    </ColAtm>
                                                                    <ColAtm item xs={8}>
                                                                        <CardContent className="border-shadow">
                                                                        <Grid container>
                                                                            <Grid item xs={11}>
                                                                            <Typography className="green-title" gutterBottom variant="h5" component="h2">
                                                                                {t('enw-inventory-title')}
                                                                            </Typography>
                                                                            </Grid>
                                                                            <Grid item xs={1}>
                                                                            <Typography className="completed-step" gutterBottom variant="h5" component="p">
                                                                                <span><i className="fas fa-arrow-right" /></span>
                                                                            </Typography>
                                                                            </Grid>
                                                                        </Grid>
                                                                        <Typography variant="body2" color="textSecondary" component="p">
                                                                            {t('enw-pab-dashboard-inventory-desc')}
                                                                        </Typography>
                                                                        </CardContent>
                                                                    </ColAtm>
                                                                    </ColAtm>
                                                                </Grid>
                                                                </Card>
                                                            </Link>
                                                            </Card>
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <Card className="offer-dashboard__box-shadow room-box mobile-mb-0 " item xs={12}>
                                                                <Card>
                                                                    <Grid container spacing={3}>
                                                                        <ColAtm>
                                                                            <ColAtm className="room_dashboard promotion" item xs={4}>
                                                                                <i className="fas fa-percent" />
                                                                            </ColAtm>
                                                                            <ColAtm item xs={8} className="border-shadow">
                                                                                <CardContent className="w-100">
                                                                                    <Link
                                                                                        to={{
                                                                                            pathname:
                                                                                                (
                                                                                                    Object.values(this.props.channel_list || {})
                                                                                                        .filter(
                                                                                                            channel =>
                                                                                                                (channel.channel_category_id === 3 || channel.channel_category_id === 4) &&
                                                                                                                channel.is_selected
                                                                                                        ).length > 1
                                                                                                )
                                                                                                    ? NETWORK_PROMOTION_CHANNEL_LIST
                                                                                                    : NETWORK_PROMOTION_SHORT + "/1",
                                                                                            state: { fromBookingEngine: true }
                                                                                        }}
                                                                                    >
                                                                                        <Grid container>
                                                                                            <Grid item xs={11}>
                                                                                                <Typography className="orange-title" gutterBottom variant="h5" component="h2">
                                                                                                    { t('enw-pab-dashboard-promotion-title') }
                                                                                                </Typography>
                                                                                            </Grid>
                                                                                            <Grid item xs={1}>
                                                                                                <Typography className="completed-step" gutterBottom variant="h5" component="p">
                                                                                                    <span className="orange"><i className="fas fa-arrow-right fs-16" /></span>
                                                                                                </Typography>
                                                                                            </Grid>
                                                                                        </Grid>
                                                                                        <Typography variant="body2" color="textSecondary" component="p">
                                                                                            { t('enw-pab-dashboard-promotion-desc') }
                                                                                        </Typography>
                                                                                    </Link>
                                                                                </CardContent>
                                                                            </ColAtm>
                                                                        </ColAtm>
                                                                        <ColAtm className="carousel-col general-carousel network-promotion-dashboard-menu">
                                                                            <Hidden xsDown>
                                                                                <ColAtm className="carousel-col general-carousel">
                                                                                    <Link
                                                                                        to={{
                                                                                            pathname:
                                                                                                (
                                                                                                    Object.values(this.props.channel_list || {})
                                                                                                        .filter(
                                                                                                            channel =>
                                                                                                                (channel.channel_category_id === 3 || channel.channel_category_id === 4) &&
                                                                                                                channel.is_selected
                                                                                                        ).length > 1
                                                                                                )
                                                                                                    ? NETWORK_PROMOTION_CHANNEL_LIST
                                                                                                    : NETWORK_PROMOTION_SHORT + "/1",
                                                                                            state: { fromBookingEngine: true }
                                                                                        }}
                                                                                    >
                                                                                        { t('enw-promotion-dashboard-title') }
                                                                                    </Link>
                                                                                    <Link
                                                                                        to={{
                                                                                            pathname:
                                                                                                (
                                                                                                    Object.values(this.props.channel_list || {})
                                                                                                        .filter(
                                                                                                            channel =>
                                                                                                                (channel.channel_category_id === 3 || channel.channel_category_id === 4) &&
                                                                                                                channel.is_selected
                                                                                                        ).length > 1
                                                                                                )
                                                                                                    ? NETWORK_ADDONS_CHANNEL_LIST
                                                                                                    : NETWORK_ADDONS_CHANNEL_LIST + "/1",
                                                                                            state: { fromBookingEngine: true }
                                                                                        }}
                                                                                    >
                                                                                        { t('enw-addon-dashboard-title') }
                                                                                    </Link>
                                                                                    <Link
                                                                                        to={{
                                                                                            pathname:
                                                                                                (
                                                                                                    Object.values(this.props.channel_list || {})
                                                                                                        .filter(
                                                                                                            channel =>
                                                                                                                (channel.channel_category_id === 3 || channel.channel_category_id === 4) &&
                                                                                                                channel.is_selected
                                                                                                        ).length > 1
                                                                                                )
                                                                                                    ? NETWORK_COUPONS_CHANNEL_LIST
                                                                                                    : NETWORK_COUPONS_CHANNEL_LIST + "/1",
                                                                                            state: { fromBookingEngine: true }
                                                                                        }}
                                                                                    >
                                                                                        { t('enw-coupon-dashboard-title') }
                                                                                    </Link>
                                                                                </ColAtm>
                                                                            </Hidden>
                                                                            <Hidden smUp>
                                                                                {/* <Carousel slidesPerPage={3}
                                                                                        infinite
                                                                                        keepDirectionWhenDragging
                                                                                        arrowLeft={<i className="fas fa-caret-left" />}
                                                                                        arrowRight={<i className="fas fa-caret-right" />}
                                                                                        addArrowClickHandler
                                                                                        arrows
                                                                                > */}
                                                                                    <Link
                                                                                        to={{
                                                                                            pathname:
                                                                                                (
                                                                                                    Object.values(this.props.channel_list || {})
                                                                                                        .filter(
                                                                                                            channel =>
                                                                                                                (channel.channel_category_id === 3 || channel.channel_category_id === 4) &&
                                                                                                                channel.is_selected
                                                                                                        ).length > 1
                                                                                                )
                                                                                                    ? NETWORK_PROMOTION_CHANNEL_LIST
                                                                                                    : NETWORK_PROMOTION_SHORT + "/1",
                                                                                            state: { fromBookingEngine: true }
                                                                                        }}
                                                                                    >
                                                                                        { t('enw-promotion-dashboard-title') }
                                                                                    </Link>
                                                                                    <Link
                                                                                        to={{
                                                                                            pathname:
                                                                                                (
                                                                                                    Object.values(this.props.channel_list || {})
                                                                                                        .filter(
                                                                                                            channel =>
                                                                                                                (channel.channel_category_id === 3 || channel.channel_category_id === 4) &&
                                                                                                                channel.is_selected
                                                                                                        ).length > 1
                                                                                                )
                                                                                                    ? NETWORK_ADDONS_CHANNEL_LIST
                                                                                                    : NETWORK_ADDONS_CHANNEL_LIST + "/1",
                                                                                            state: { fromBookingEngine: true }
                                                                                        }}
                                                                                    >
                                                                                        { t('enw-addon-dashboard-title') }
                                                                                    </Link>
                                                                                    <Link
                                                                                        to={{
                                                                                            pathname:
                                                                                                (
                                                                                                    Object.values(this.props.channel_list || {})
                                                                                                        .filter(
                                                                                                            channel =>
                                                                                                                (channel.channel_category_id === 3 || channel.channel_category_id === 4) &&
                                                                                                                channel.is_selected
                                                                                                        ).length > 1
                                                                                                )
                                                                                                    ? NETWORK_COUPONS_CHANNEL_LIST
                                                                                                    : NETWORK_COUPONS_CHANNEL_LIST + "/1",
                                                                                            state: { fromBookingEngine: true }
                                                                                        }}
                                                                                    >
                                                                                        { t('enw-coupon-dashboard-title') }
                                                                                    </Link>
                                                                                {/* </Carousel> */}
                                                                            </Hidden>
                                                                        </ColAtm>
                                                                    </Grid>
                                                                </Card>
                                                            </Card>
                                                        </Grid>
                                                        {showDailyReports && (
                                                            <Grid xs={6}>
                                                                <Link className="download-content-pdf-btn be-scrn-tools" to={DAILY_REPORTS}> 
                                                                    <i style={{marginRight: 5}} class="fas fa-chart-pie"/> { t('enw-daily_reports-title') }
                                                                </Link>
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                        }
                                    </Grid>
                            }
                        </div>
                    </Grid>
                    <style>{`
                    .rm-circular-progress {
                        position: relative !important;
                    }
                    @media screen and (max-width: 768px) {
                        .dashboard-tools > div:nth-last-child(-n + 2) {
                            margin-top:5px !important;
                        }
                    }
                    .MuiDrawer-paper::-webkit-scrollbar {
                        width: 4px;
                    }

                    .MuiDrawer-paper::-webkit-scrollbar-track {
                        background: transparent;
                    }

                    .MuiDrawer-paper::-webkit-scrollbar-thumb {
                        background: #d1d5db;
                        border-radius: 4px;
                    }

                    .MuiDrawer-paper::-webkit-scrollbar-thumb:hover {
                        background: #9ca3af;
                    }

                    @media (min-width: 960px) and (max-width: 1600px) {
                        .MuiDrawer-paper {
                            height: calc(125vh - 81px) !important;
                            min-height: calc(125vh - 101px) !important;
                        }
                        
                        .sidebar-items, .active-sidebar {
                            padding: 10px 14px !important;
                        }
                        
                        .sidebar-items i,
                        .active-sidebar i {
                            font-size: 16px !important;
                        }
                        
                        .dashboard-menu {
                            font-size: 12px !important;
                        }
                    }

                    .MuiDrawer-paper {
                        &:hover {
                            .sidebar-text-animated {
                                opacity: 1 !important;
                                transform: translateX(0) !important;
                            }
                        }
                    }
                    @media (min-width: 1500px) {
                        .be-container-width {
                            padding: 70px 0px 0px 150px !important;
                        }
                    }
                    .offer-boxes {
                        height:200px !important;
                        margin-top:8px !important;
                    }
                `}</style>
                </Grid>
                <Hidden mdUp>
                    <BottomNavigation className="m-navigation" value="booking">
                        <BottomNavigationAction value="content" icon={<i className="fas fa-hotel" />} onClick={() => { history.push(CONTENT)}}  />
                        <BottomNavigationAction value="web" icon={<i className="fas fa-network-wired" />} onClick={() => { history.push(!this.props.propertyProductsReducer.fetching ?isDefined(allowedPageWeb[0]) && allowedPageWeb[0].property_has_product ? WEB :  NOT_ALLOWED_DASHBOARD_SHORT + "/web" : "#")}} />
                        <BottomNavigationAction value="booking" icon={<i className="fas fa-calendar-alt" />} />
                        <BottomNavigationAction value="payment" icon={<i className="fas fa-money-bill-wave-alt" />} onClick={() => {history.push(!this.props.propertyProductsReducer.fetching ? isDefined(allowedPagePayment[0]) && allowedPagePayment[0].property_has_product ? PAYMENT :  NOT_ALLOWED_DASHBOARD_SHORT + "/payment" : "#")}} />
                        <BottomNavigationAction value="offer" icon={<i className="fas fa-paperclip" />} onClick={() => { history.push(!this.props.propertyProductsReducer.fetching ?isDefined(allowedPageOffer[0]) && allowedPageOffer[0].property_has_product ? OFFER : NOT_ALLOWED_DASHBOARD_SHORT + "/offer" : "#")}} />
                        <BottomNavigationAction value="network" icon={<i className="fas fa-chart-network" />} onClick={() => { history.push(!this.props.propertyProductsReducer.fetching ?isDefined(allowedPageNetwork[0]) && allowedPageNetwork[0].property_has_product ? NETWORK : NOT_ALLOWED_DASHBOARD_SHORT + "/network" : "#")}} />
                        <BottomNavigationAction value="competitor-analysis" icon={<i className="fas fa-analytics" />} onClick={() => { history.push(NETWORK_COMPETITOR_DASH) }} />
                        <BottomNavigationAction
                            value="reputation-management"
                            icon={<i className="fas fa-comments-alt" />}
                            onClick={() => { history.push(!this.props.propertyProductsReducer.fetching ? isDefined(allowedPageReputationManagement[0]) && allowedPageReputationManagement[0].property_has_product ? REPUTATION_MANAGEMENT : NOT_ALLOWED_DASHBOARD_SHORT + "/reputation-management" : "#")}}
                        />
                    </BottomNavigation>
                </Hidden>
            </>
        )
    }
}
const mapStateToProps = (props) => {
    return {
        profileReducer : props.profileReducer,
        bookingEngine: props.BookingEngineDashboardReducers.bookingEngineData,
        bookingEngineReducer: props.BookingEngineDashboardReducers,
        propertyProductsReducer : props.propertyProductsReducer,
        networkDashboardReducer: props.networkDashboardReducer,
        channel_list: props.channelListReducers.channel_list,
    }
};

const mapDispatchToProps = {
    getProfile,
    getBookingEngineDashboard,
    propertyProducts,
    getNetworkDashboard,
    listChannels
};

export default compose(withTranslation('common')) (connect(mapStateToProps, mapDispatchToProps )(CreateWeb));
